export default {
  translations: { // namespace
    home: {
      messageTitle: 'Lets create your next video advertisement?',
      message: 'Multiply is a tool to create video advertisements with the brands you work with.',
      emailInput: 'Step 1: Inform your email to continue',
      submitEmail: 'Continue',
      emailPlaceholder: 'Input here...',
      downloadAppTitle: 'Download or access app'
    }
  }
};
